"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _remove = _interopRequireDefault(require("lodash/remove"));

var _queryString = _interopRequireDefault(require("query-string"));

var _history = _interopRequireDefault(require("../../../util/history"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _map = _interopRequireDefault(require("lodash/map"));

var _SearchFilterModel = _interopRequireDefault(require("./filters/SearchFilterModel"));

var _TypeaheadFilterModel = _interopRequireDefault(require("./filters/TypeaheadFilterModel"));

var _SelectFilterModel = _interopRequireDefault(require("./filters/SelectFilterModel"));

var _CheckboxFilterModel = _interopRequireDefault(require("./filters/CheckboxFilterModel"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _mapKeys = _interopRequireDefault(require("lodash/mapKeys"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _toLower = _interopRequireDefault(require("lodash/toLower"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _TableRowModel = _interopRequireDefault(require("./TableRowModel"));

var _LoadingStates = _interopRequireDefault(require("./LoadingStates"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var BaseTableModel = (_class = /*#__PURE__*/function () {
  function BaseTableModel(props) {
    _classCallCheck(this, BaseTableModel);

    _initializerDefineProperty(this, "itemsPerPage", _descriptor, this);

    _initializerDefineProperty(this, "currentPage", _descriptor2, this);

    _initializerDefineProperty(this, "filters", _descriptor3, this);

    _initializerDefineProperty(this, "sorts", _descriptor4, this);

    this.itemsPerPage = !(0, _isUndefined.default)(props.itemsPerPage) ? props.itemsPerPage : 10;
    this.currentPage = !(0, _isUndefined.default)(props.currentPage) ? props.currentPage : 0;
    this.definition = props.definition;
    this.dispatcher = null;

    this._instantiateFilterModels();
  }

  _createClass(BaseTableModel, [{
    key: "bindDispatcher",
    value: function bindDispatcher(dispatcher) {
      this.dispatcher = dispatcher;
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return true;
    }
  }, {
    key: "onMount",
    value: function onMount(dispatcher) {
      this.bindDispatcher(dispatcher);

      if (this.loadState === _LoadingStates.default.UI_NOT_READY) {
        this.loadState = _LoadingStates.default.UI_READY;
      } else if (this.loadState === _LoadingStates.default.DATA_REFRESH_NEEDED) {
        this.loadState = _LoadingStates.default.UI_READY;
        this.refreshTable();
      }
    }
  }, {
    key: "changePage",
    value: function changePage(newPage) {
      this.currentPage = newPage;
    }
  }, {
    key: "updateItemsPerPage",
    value: function updateItemsPerPage(newPageSize) {
      this.itemsPerPage = newPageSize;
      this.currentPage = 0;
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(filterKey, newValue) {
      var filterModel = this.filters.get(filterKey);
      filterModel.updateValue(newValue);

      if (!filterModel.isNoOp) {
        // since we are looking at a new set of data, we want to reset to the first page
        this.currentPage = 0;
      }

      if (this.enableHistory && window && window.location) {
        var queryStringParams = _queryString.default.parse(window.location.search);

        if (queryStringParams[filterKey] !== newValue) {
          queryStringParams[filterKey] = newValue;
          var query = (0, _isEmpty.default)(queryStringParams) ? "" : "?" + _queryString.default.stringify(queryStringParams);
          var newUrl = window.location.origin + window.location.pathname + query;

          _history.default.pushState({}, "", newUrl);
        }
      }
    }
  }, {
    key: "updateSort",
    value: function updateSort(columnName) {
      var sortDescending = false;
      var oldSortConfig = (0, _remove.default)(this.sorts, function (sortDefinition) {
        return sortDefinition.iteratee === columnName;
      })[0];

      if (!(0, _isUndefined.default)(oldSortConfig)) {
        sortDescending = !oldSortConfig.descending;
      }

      (0, _forEach.default)(this.sorts, function (sort) {
        sort.primary = false;
      });
      this.sorts.push({
        iteratee: columnName,
        descending: sortDescending,
        primary: true
      });
    }
  }, {
    key: "_instantiateFilterModels",
    value: function _instantiateFilterModels() {
      var _this = this;

      var filterModels = (0, _map.default)( // TODO add support for other kinds of filters
      (0, _filter.default)(this.filterOptions, function (filterDefinition) {
        return (0, _includes.default)(["search", "select", "hidden", "checkbox", "typeahead"], filterDefinition.type);
      }), function (filterDefinition) {
        if (filterDefinition.type === "search") {
          return new _SearchFilterModel.default(filterDefinition);
        } else if (filterDefinition.type === "typeahead") {
          return new _TypeaheadFilterModel.default(filterDefinition);
        } else if (filterDefinition.type === "select" || filterDefinition.type === "hidden") {
          return new _SelectFilterModel.default(filterDefinition);
        } else if (filterDefinition.type === "checkbox") {
          return new _CheckboxFilterModel.default(filterDefinition);
        } // unsupported filter types should be filtered out above, should never get here.


        return null;
      });
      (0, _forEach.default)(filterModels, function (model) {
        _this.filters.set(model.key, model);
      });
    }
  }, {
    key: "parseUrlSearchQuery",
    value: function parseUrlSearchQuery(urlSearchQuery) {
      var queryStringParams = (0, _mapKeys.default)(_queryString.default.parse(urlSearchQuery), function (value, key) {
        return (0, _toLower.default)(key);
      }); // filters is an observable map, use the builtin foreach

      this.filters.forEach(function (f, key) {
        var filterValue = queryStringParams[(0, _toLower.default)(key)] || f.defaultValue;
        f.updateValue(filterValue);
      });
      this.refreshTable();
    }
  }, {
    key: "refreshTable",
    value: function refreshTable() {// noop - used by DynamicTableModel, kept here for consistency
    }
  }, {
    key: "searchFilter",
    get: function get() {
      return this.filters.get("search");
    }
  }, {
    key: "columnOptions",
    get: function get() {
      return this.definition.columnOptions;
    }
  }, {
    key: "rowOptions",
    get: function get() {
      return this.definition.rowOptions;
    }
  }, {
    key: "filterOptions",
    get: function get() {
      return this.definition.filterOptions;
    }
  }, {
    key: "emptyTableFormatter",
    get: function get() {
      return this.definition.emptyTableFormatter;
    }
  }, {
    key: "enableHistory",
    get: function get() {
      return this.definition.enableHistory || false;
    }
  }, {
    key: "createRowModel",
    value: function createRowModel(data) {
      return new _TableRowModel.default(data);
    }
  }]);

  return BaseTableModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "itemsPerPage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentPage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "filters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return _mobx.observable.map({});
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sorts", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _mobx.observable)([]);
  }
}), _applyDecoratedDescriptor(_class.prototype, "changePage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "changePage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateItemsPerPage", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateItemsPerPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateFilter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSort", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instantiateFilterModels", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "_instantiateFilterModels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parseUrlSearchQuery", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "parseUrlSearchQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshTable", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshTable"), _class.prototype)), _class);
var _default = BaseTableModel;
exports.default = _default;